import React from 'react'
import AlertModal from './AlertModal';
import TextTermsOfUse from '../Shared/TextTermsOfUse';
import { useTranslation } from 'react-i18next';

const ShowTermsOfUseModal = (props) => {

  const { t } = useTranslation();

  return (
    <AlertModal modalTitle={ t( 'modal.terms_of_use.title' ) }>
      <TextTermsOfUse />
    </AlertModal>
  )
}

export default ShowTermsOfUseModal



// WEBPACK FOOTER //
// ./src/components/Modals/ShowTermsOfUseModal.js